import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `ButtonDirective` represent a button of the react dialog.
 * It must be contained in a Dialog component(`DialogComponent`).
 * ```tsx
 * <DialogComponent showCloseIcon={true}>
 *   <ButtonsDirective>
 *     <DialogbuttonDirective buttonModal={this.okButton}></DialogbuttonDirective>
 *     <DialogbuttonDirective buttonModal={this.cancelButton}></DialogbuttonDirective>
 *   <ButtonsDirective>
 * </DialogComponent>
 * ```
 */
export class DialogButtonDirective extends ComplexBase {
}
DialogButtonDirective.moduleName = 'dialogButton';
export class ButtonsDirective extends ComplexBase {
}
ButtonsDirective.propertyName = 'buttons';
ButtonsDirective.moduleName = 'buttons';
